import { Header, Table } from 'components'

import { TRADE_SHOWS_SUMMARY } from './tradeShowsSummary.generated'

/**
 * VRG-673 — the parts of the Trade shows page that exist BEFORE its data loads: the header
 * copy and the skeleton. Kept out of `GtmTradeShowsPage.tsx` on purpose. That page imports the
 * 120 KB event snapshot and is `React.lazy` in App.tsx so the snapshot never enters the entry
 * bundle; this module is what App.tsx imports EAGERLY as the Suspense fallback, so it must not
 * import the snapshot (only the few-hundred-byte summary).
 */

export const TRADE_SHOWS_TITLE = 'Trade shows'

export const TRADE_SHOWS_DESCRIPTION = `Events per industry, from the GTM trade-show calendar. Prices checked ${TRADE_SHOWS_SUMMARY.priceCheckedOn}. Read-only: confirm the date and price on the organizer's page before booking.`

/** The header labels, in page order, so the skeleton's columns match the loaded table's. */
export const TRADE_SHOW_COLUMN_HEADERS: ReadonlyArray<{ field: string; headerName: string; width: number }> = [
  { field: 'event', headerName: 'Event', width: 260 },
  { field: 'dates', headerName: 'Dates', width: 230 },
  { field: 'city', headerName: 'City', width: 170 },
  { field: 'industry', headerName: 'Industry', width: 250 },
  { field: 'month', headerName: 'Month', width: 120 },
  { field: 'fit', headerName: 'Fit', width: 150 },
  { field: 'date_status', headerName: 'Date status', width: 150 },
  { field: 'tickets', headerName: 'Tickets', width: 220 },
  { field: 'booth', headerName: 'Booth', width: 220 },
  { field: 'plan', headerName: 'Plan to attend', width: 150 },
  { field: 'why_vera', headerName: 'Why Vera', width: 320 },
  { field: 'lastCheckedOn', headerName: 'Last checked', width: 190 },
]

/**
 * Footprint parity with the loaded page (§19): the same Header (title, count, description) and
 * the same full-page Table, whose own column-aware skeleton fills the grid while `loading`.
 * The description reads the summary, so it is the identical string before and after loading.
 */
export const TradeShowsSkeleton = () => (
  <>
    <Header
      title={TRADE_SHOWS_TITLE}
      total={TRADE_SHOWS_SUMMARY.events}
      description={TRADE_SHOWS_DESCRIPTION}
    />
    {/* `type: 'string'`: the Table's filter panel logs an error for any column without one. */}
    <Table
      fillBottom
      loading
      rows={[]}
      columns={TRADE_SHOW_COLUMN_HEADERS.map((c) => ({ ...c, type: 'string', sortable: false }))}
      hideExport
    />
  </>
)
